<template>
  <div>
    <div class="info-block" v-if="statusNotWorking">
      <icon name="information" class="info-icon" />
      <span class="info-label">
        {{ $t("identification.click_start_to_start") }}
      </span>
    </div>
    <div v-else-if="showLoader" class="info-block">
      <ui-loader />
      <span class="info-label">{{ loaderLabel }}</span>
    </div>
    <div class="info-block" v-else-if="showError">
      <icon name="alert-circle" class="info-icon error" />
      <span class="info-label">{{ errorLabel }}</span>
    </div>
    <identification-details v-else-if="statusChecking" />
    <div v-else>
      <b>Work status:</b> {{ work.status }}<br />
      <b>Identification status:</b>
      {{ currentIdentification && currentIdentification.status }}
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import IdentificationDetails from "@/components/IdentificationDetails";
import { getters } from "@/store";
import { IDENTIFICATION_LOCAL_STATUS, WORK_LIVE_STATUSES, WORK_STATUS } from "@/constants";
export default {
  components: { IdentificationDetails },
  computed: {
    ...mapState({
      work: state => state.work
    }),
    ...mapGetters([getters.currentIdentification, getters.currentIdentificationStatus]),
    statusNotWorking() {
      return [WORK_STATUS.NOT_STARTED, WORK_STATUS.STOPPED].includes(this.work.status);
    },
    statusWorkStartError() {
      return [WORK_STATUS.START_ERROR].includes(this.work.status);
    },
    statusStartingWork() {
      return this.work.status === WORK_STATUS.STARTING;
    },

    statusWorking() {
      return WORK_LIVE_STATUSES.includes(this.work.status);
    },
    statusWaitingForIdentification() {
      return this.statusWorking && !this.currentIdentification?.id;
    },
    statusLoadingIdentification() {
      const identification = this.currentIdentification;
      return this.statusWorking && identification?.status === IDENTIFICATION_LOCAL_STATUS.LOADING && identification?.loaded === false;
    },
    statusReLoadingIdentification() {
      const identification = this.currentIdentification;
      return this.statusWorking && identification?.status === IDENTIFICATION_LOCAL_STATUS.LOADING && identification?.loaded === true;
    },
    statusIdentificationLoadError() {
      return this.statusWorking && this.currentIdentification?.status === IDENTIFICATION_LOCAL_STATUS.LOAD_ERROR;
    },
    statusChecking() {
      return this.statusReLoadingIdentification || (this.statusWorking && [IDENTIFICATION_LOCAL_STATUS.CHECKING, IDENTIFICATION_LOCAL_STATUS.APPROVING, IDENTIFICATION_LOCAL_STATUS.APPROVE_ERROR, IDENTIFICATION_LOCAL_STATUS.REJECTING, IDENTIFICATION_LOCAL_STATUS.REJECT_ERROR].includes(this.currentIdentification?.status));
    },
    showLoader() {
      return this.statusStartingWork || this.statusWaitingForIdentification || this.statusLoadingIdentification;
    },
    loaderLabel() {
      if (this.statusStartingWork) {
        return this.$t("identification.work_starting");
      } else if (this.statusWaitingForIdentification) {
        return this.$t("identification.waiting_for_identification");
      } else if (this.statusLoadingIdentification) {
        return this.$t("identification.loading_identification");
      }
      return "";
    },
    showError() {
      return this.statusWorkStartError || this.statusIdentificationLoadError;
    },
    errorLabel() {
      if (this.statusWorkStartError) {
        return this.$t("identification.work_error", {
          error: this.work.error
        });
      } else if (this.statusIdentificationLoadError) {
        return this.$t("identification.identification_error", {
          id: this.currentIdentification?.identificationId,
          error: this.currentIdentification?.error
        });
      }
      return "";
    }
  }
};
</script>

<style scoped lang="scss">
.info-block {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 25rem;
  padding: 1rem;
  margin: 0 auto;
}
.info-label {
  display: block;
  margin-top: 1rem;
  text-align: center;
}
.info-icon {
  width: 5rem;
  height: 5rem;
  fill: var(--text-secondary);
  &.error {
    fill: var(--text-danger);
  }
}
</style>
